import { BlocksIconDashboard2 } from 'blocks-nextjs/blocks-web-components/components/icon/icons/dashboard2';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconDashboard2 = createComponent({
  react: React,
  tagName: 'cat-icon-dashboard2',
  elementClass: BlocksIconDashboard2
});
